import {
  Component,
  HostBinding,
  HostListener,
  Input,
  OnDestroy,
  OnInit,
} from '@angular/core';

@Component({
  selector: 'app-lastplayers',
  templateUrl: './lastplayers.component.html',
  styleUrls: ['./lastplayers.component.scss'],
})
export class LastplayersComponent implements OnInit, OnDestroy {
  lastPlayers: string[] = [];
  defaultRoom: string = 'Haunted Motel';
  currentSlide: number = 0;
  slideInterval: any;
  isScreenWidthAbove1000px: boolean = true;

  @Input() loading: boolean = false;
  @Input() theme: string = '';

  @Input('lastPlayers')
  set setLastPlayers(lastPlayers: any[]) {
    if (lastPlayers) {
      this.lastPlayers = [];
      this.currentSlide = 0;
      lastPlayers.forEach((lastPlayer) => {
        lastPlayer.data.forEach((player: { picture: string }) => {
          this.lastPlayers.push(player.picture);
        });
      });
      this.updateSlidePosition();
    }
  }

  @HostBinding('class.light-theme') get isLightTheme() {
    return this.theme === 'light';
  }
  @HostBinding('class.dark-theme') get isDarkTheme() {
    return this.theme === 'dark';
  }

  @HostListener('window:resize', ['$event'])
  onResize() {
    this.isScreenWidthAbove1000px = window.innerWidth > 1000;
    this.updateSlidePosition();
  }

  ngOnInit() {
    this.startSlideShow();
    this.checkScreenWidth();
  }

  ngOnDestroy() {
    clearInterval(this.slideInterval);
  }

  checkScreenWidth() {
    this.isScreenWidthAbove1000px = window.innerWidth > 1000;
  }

  startSlideShow() {
    this.slideInterval = setInterval(() => {
      this.nextSlide();
    }, 3000);
  }

  nextSlide() {
    const total = this.lastPlayers.length;
    const visible = this.visibleCount;
    const maxStart = Math.max(total - visible, 0);
    this.currentSlide =
      this.currentSlide < maxStart ? this.currentSlide + 1 : 0;
    this.updateSlidePosition();
  }

  updateSlidePosition() {
    const carouselInner = document.querySelector(
      '.carousel-inner',
    ) as HTMLElement;
    if (!carouselInner) return;
    const firstItem = carouselInner.querySelector(
      '.carousel-item',
    ) as HTMLElement;
    if (!firstItem) return;

    // Shift by exactly one item width (+gap) per slide
    const itemRect = firstItem.getBoundingClientRect();
    const styles = getComputedStyle(carouselInner);
    const gapPx = parseFloat(styles.gap || '0') || 0;
    const shiftPerItem = itemRect.width + gapPx;
    const translatePx = -this.currentSlide * shiftPerItem;
    carouselInner.style.transform = `translateX(${translatePx}px)`;
  }

  clearSlideInterval() {
    if (this.slideInterval) {
      clearInterval(this.slideInterval);
    }
  }

  getIndicators() {
    const total = this.lastPlayers.length;
    const visible = this.visibleCount;
    const count = Math.max(total - visible + 1, 0);
    return Array.from({ length: count }, (_, i) => i);
  }

  goToSlide(index: number) {
    this.clearSlideInterval();
    const total = this.lastPlayers.length;
    const visible = this.visibleCount;
    const maxStart = Math.max(total - visible, 0);
    this.currentSlide = Math.min(Math.max(index, 0), maxStart);
    this.updateSlidePosition();
  }

  private get visibleCount(): number {
    return this.isScreenWidthAbove1000px ? 4 : 1;
  }

  getVisiblePlayers(): string[] {
    const start = this.currentSlide;
    const end = start + this.visibleCount;
    return this.lastPlayers.slice(start, end);
  }
}
